import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiUserRelationshipQueryResponse,
  GetApiUserRelationship401,
  GetApiUserRelationship403,
} from "../../../types/GetApiUserRelationship";

export function getGetApiUserRelationshipUrl() {
  return `/api/User/relationship` as const;
}

/**
 * {@link /api/User/relationship}
 */
export async function getApiUserRelationship(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiUserRelationshipQueryResponse,
    ResponseErrorConfig<GetApiUserRelationship401 | GetApiUserRelationship403>,
    unknown
  >({
    method: "GET",
    url: getGetApiUserRelationshipUrl().toString(),
    ...requestConfig,
  });
  return res;
}
